export var Type;
(function (Type) {
    Type["Audio"] = "audio";
    Type["Banner"] = "banner";
    Type["Card"] = "card";
    Type["Carousel"] = "carousel";
    Type["Code"] = "code";
    Type["Container"] = "container";
    Type["GradedText"] = "gradedText";
    Type["Heading"] = "heading";
    Type["Image"] = "image";
    Type["Link"] = "link";
    Type["List"] = "list";
    Type["Modal"] = "modal";
    Type["Padding"] = "padding";
    Type["Quote"] = "quote";
    Type["Scrollable"] = "scrollable";
    Type["Separator"] = "separator";
    Type["Span"] = "span";
    Type["Text"] = "text";
    Type["Video"] = "video";
})(Type || (Type = {}));
export default Type;
//# sourceMappingURL=Type.js.map